import React from 'react'
import { Form, Input, Button, Row, Col } from 'antd'
import PropTypes from 'prop-types'
import { compose, Mutation } from 'react-apollo'
import localization from 'utils/localization'
import REGISTER_USER_PHONE from 'api/mutation/registerUserPhone.gql'

class RegistrationPhoneStep extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault()

    this.props.form.validateFields((error, value) => {
      if (!error) {
        this.props.registerUserPhoneStep({
          variables: { input: value }
        }).then(resp => {
          if (resp.data.registerUserPhoneStep.errors.length) {
            return Promise.reject(resp.data.registerUserPhoneStep.errors)
          }
          this.setState({
            error: false
          })
          this.props.phoneValidated(value.phone)
        }).catch(errors => {
          this.props.form.setFields({
            phone: {
              value: value.phone,
              errors
            }
          })
        })
      }
    })
  }
  render () {
    const { form: { getFieldDecorator }, loading } = this.props
    return (
      <div className='form_wrapper'>
        <Row type='flex' justify='center' style={{ marginBottom: '20px' }}>
          <Col type='flex' justify='center' style={{ textAlign: 'center' }}>
            <h1 className='h1-style-inverse '>{localization.auth.signUp}</h1>
          </Col>
        </Row>
        <form onSubmit={this.handleSubmit}>
          <Row type='flex' justify='center'>
            <Col type='flex' justify='center' style={{ textAlign: 'center' }}>
              <Form.Item>
                {getFieldDecorator('phone', { initialValue: '',
                  rules: [ { required: true, message: localization.form.requiredField } ]
                })(
                  <Input type='text' placeholder={localization.phone} />
                )}
              </Form.Item>
            </Col>
          </Row>
          <div>
            <Row type='flex' justify='center'>
              <Col type='flex' justify='center' style={{ textAlign: 'center' }}>
                <Button className='primary-button' type='primary' htmlType='submit' loading={loading}>
                  {localization.submit}
                </Button>
              </Col>
            </Row>
          </div>
        </form>
      </div>)
  }
}

RegistrationPhoneStep.propTypes = {
  registerUserPhoneStep: PropTypes.func.isRequired,
  phoneValidated: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
}

export default compose(
  Form.create()
)(props => (
  <Mutation mutation={REGISTER_USER_PHONE}>
    {(registerUserPhoneStep, { loading }) => (
      <RegistrationPhoneStep registerUserPhoneStep={registerUserPhoneStep} loading={loading} {...props} />
    )}
  </Mutation>
))
